import { STRAPI_URL, parseErrorMessage, strapiAuthHeaders, strapiMediaUrl } from './strapi';

export type StrapiUserSigned = {
  documentId: string;
  file_path: string;
  file_url: string;
  createdAt: string | null;
  updatedAt: string | null;
  sign: string;
};

function asRecord(v: unknown): Record<string, unknown> | null {
  return v && typeof v === 'object' && !Array.isArray(v) ? (v as Record<string, unknown>) : null;
}

function normalizeRow(raw: Record<string, unknown> | null): StrapiUserSigned | null {
  if (!raw) return null;
  const filePath = String(raw.file_path ?? '').trim();
  if (!filePath) return null;
  const sign = String(raw.sign ?? '').trim();
  return {
    documentId: String(raw.documentId ?? '').trim(),
    file_path: filePath,
    file_url: strapiMediaUrl(filePath),
    createdAt: raw.createdAt != null ? String(raw.createdAt) : null,
    updatedAt: raw.updatedAt != null ? String(raw.updatedAt) : null,
    sign,
  };
}

/** `GET /api/user-signeds/mine` — default signature for the signed-in user. */
export async function strapiFetchMyUserSigned(jwt: string): Promise<StrapiUserSigned | null> {
  const res = await fetch(`${STRAPI_URL}/api/user-signeds/mine`, {
    headers: strapiAuthHeaders(jwt),
  });
  const body = (await res.json().catch(() => ({}))) as unknown;
  if (!res.ok) throw new Error(parseErrorMessage(body, res.status));
  return normalizeRow(asRecord(asRecord(body)?.data));
}

/** `POST /api/user-signeds/mine` — upsert default signature from a PNG data URL. */
export async function strapiSaveMyUserSigned(jwt: string, sign: string): Promise<StrapiUserSigned> {
  const res = await fetch(`${STRAPI_URL}/api/user-signeds/mine`, {
    method: 'POST',
    headers: {
      ...strapiAuthHeaders(jwt),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ sign }),
  });
  const body = (await res.json().catch(() => ({}))) as unknown;
  if (!res.ok) throw new Error(parseErrorMessage(body, res.status));
  const row = normalizeRow(asRecord(asRecord(body)?.data));
  if (!row) throw new Error('Gagal menyimpan tanda tangan default.');
  return row;
}

/** `DELETE /api/user-signeds/mine` — hard-delete the default signature. */
export async function strapiDeleteMyUserSigned(jwt: string): Promise<void> {
  const res = await fetch(`${STRAPI_URL}/api/user-signeds/mine`, {
    method: 'DELETE',
    headers: strapiAuthHeaders(jwt),
  });
  const body = (await res.json().catch(() => ({}))) as unknown;
  if (!res.ok) throw new Error(parseErrorMessage(body, res.status));
}

export function normalizeUserSignedRowForTest(raw: unknown): StrapiUserSigned | null {
  return normalizeRow(asRecord(raw));
}
